import { css } from '@emotion/core';

const styles =  {
  paneLayout: {
    sidebar: css`
      display: flex;
      flex-direction: column;
    `,

    header: css`
        margin-bottom: 1rem;
        padding: 1rem;
        box-shadow: 2px 2px 2px var(--neutral-6-translucent);
      `,

    section: css`
      display: flex;
      flex-direction: column;
      width: calc(100% - 1rem);
      margin: 0.5rem;
      padding: 0 0.3rem 0.3rem 0.3rem;
    `,

    dominantSection: css`
      flex-grow: 1;
      overflow-y: auto;
    `,
  },

  buttons: {
    blockButton: css`
      &.ui-link {
        padding: 0.2em 2em;
        box-shadow: 2px 2px 2px rgba(0,0,0,0.4);
        border-radius: var(--button-border-radius);
        /* transition: 200ms; */
      }
    `,

    primary: css`
      &.ui-link {
        background: var(--primary);
        color: var(--text-white);
      }
    `,

    danger: css`
      &.ui-link {
        background: var(--danger);
        color: var(--text-white);
      }
    `,

    disabled: css`
      &.ui-link, &.ui-link:hover {
        background: var(--disabled-gray);
        color: var(--neutral-4);
        cursor: default;
      }
    `,

    small: css`
      &.ui-link {
        font-size: 0.8rem;
        padding: 4px 6px;
      }
    `,

    withIcon: css`
      display: flex;
      align-items: center;
    `,

  },

  forms: {
    loginField: css`
        text-indent: 2em;
        width: 250px;
        order: 1;
      `,

    loginIcon: css`
      order: 0;
      color: var(--text-white);
      position: absolute;
      /* transition: 400ms; */
      *:focus ~ & {
        color: var(--electra);
      }
    `,
  },

  icons: {
    bpInlineButton: css`
    margin: 0 0.5em;
  `,

    colorThumb: color => css`
        &, &.ui-link {
          height: 1rem;
          width: 1rem;
          margin: 0.25rem;

          background: ${color};
          border: 1px solid var(--fybr-slate);
          border-radius: var(--button-border-radius);
        }
      `
  },

  theme: {
    dark: css`
      background: var(--fybr-slate);
      color: var(--text-white);
    `,
  },
};

export default styles;
